import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { tap } from "rxjs/operators";
import { InitiateWorkflowRequest, WorkflowData, MetadataSearchSpec, WorkflowSearchSpec, ApplicationStateChangeRequest, ApplicationEventType, ApplicationPermitResult, GeneratePermitRequest, CommitFilesRequest, WorkflowNote, ApplicationType } from "../models/applications.models";
import { PaymentReceivedDateRequest, PendingFlow } from "../../flow/models/flow.model";


@Injectable({
    providedIn: 'root'
})
export class ApplicationsService {

    static BaseUrl: string = "/api/applications";

    private eventTypes: ApplicationEventType[] = [];

    constructor(private http: HttpClient) { }


   
    //getApplication(applicationId: number): Observable<WorkflowData> {
    //    return this.http.get<WorkflowData>(`${ApplicationsService.BaseUrl}/get/${applicationId}`);
    //}

    commitAssociatedDocuments(applicationNumber: string, confidential: boolean): Observable<any> {
        let request: CommitFilesRequest = { applicationNumber: applicationNumber, confidential: confidential } as CommitFilesRequest;
        return this.http.post<any>(`${ApplicationsService.BaseUrl}/commit-files/`, request)
    }

    generatePermit(application: WorkflowData, uploadDocument: boolean): Observable<ApplicationPermitResult> {
        let request: GeneratePermitRequest = {
            workflowId: application.id,
            applicationNumber: application.applicationNumber,
            uploadDocument: uploadDocument
        } as GeneratePermitRequest;
        return this.http.post<ApplicationPermitResult>(`${ApplicationsService.BaseUrl}/generate-permit`, request);
    }

    getApplicationByApplicationNumber(applicationNumber: string): Observable<WorkflowData> {
        return this.http.get<WorkflowData>(`${ApplicationsService.BaseUrl}/get-by-application-number/${applicationNumber}`);
    }

    getApplicationEventTypes(): Observable<ApplicationEventType[]> {
        if (this.eventTypes != null && this.eventTypes.length > 0) return of(this.eventTypes);
        return this.http.get<ApplicationEventType[]>(`${ApplicationsService.BaseUrl}/get-event-types`).pipe(
            tap((data: ApplicationEventType[]) => {
                this.eventTypes = data;
            })
        )
    }

    initiateApplication(request: InitiateWorkflowRequest): Observable<WorkflowData> {
        return this.http.post<WorkflowData>(`${ApplicationsService.BaseUrl}/create`, request);
    }

    recordPaymentDate(request: PaymentReceivedDateRequest): Observable<any> {
        return this.http.post<any>(`${ApplicationsService.BaseUrl}/record-payment-date`, request);
    }


    routeApplication(request: ApplicationStateChangeRequest): Observable<WorkflowData> {
        return this.http.post<WorkflowData>(`${ApplicationsService.BaseUrl}/route-application`, request);
    }

    saveApplication(application: WorkflowData): Observable<WorkflowData> {
        var notes: WorkflowNote[] = [];
        if (application.workflowType == ApplicationType.ComplianceReporting) {
            if (application.workflowNotes != null) {
                for (let i = 0; i < application.workflowNotes.length; i++) {
                    notes.push(application.workflowNotes[i]);
                    if (application.workflowNotes[i].childNotes != null) {
                        notes.concat(application.workflowNotes[i].childNotes);
                    }
                }
            }
            else {
                application.workflowNotes = [];
            }     
        }

        else if (application.workflowType == ApplicationType.Stratigraphic) {

        if (application.workflowNotes != null) {
            for (let i = 0; i < application.workflowNotes.length; i++) {
                notes.push(application.workflowNotes[i]);
                if (application.workflowNotes[i].childNotes != null) {
                    for (let j = 0; j < application.workflowNotes[i].childNotes.length; j++) {
                        if (notes.includes(application.workflowNotes[i].childNotes[j]) == false) {
                        }
                        notes.push(application.workflowNotes[i].childNotes[j])
                    }
                }
            }

        }
        else {

            application.workflowNotes = [];
        }

    }

        application.workflowNotes = notes;


        return this.http.post<WorkflowData>(`${ApplicationsService.BaseUrl}/save-application`, application);
	}

	searchApplications(spec: WorkflowSearchSpec): Observable<WorkflowData[]> {
		return this.http.post<WorkflowData[]>(`${ApplicationsService.BaseUrl}/search-applications`, spec);
	}

    searchMetadata(spec: MetadataSearchSpec): Observable<PendingFlow[]> {
        return this.http.post<PendingFlow[]>(`${ApplicationsService.BaseUrl}/search-metadata`, spec);
    }

    
}
